const place = [
    { id: 1, name: "17 شهریور جدید", isCheck: false },
    { id: 2, name: "17 شهریور قدیم", isCheck: false },
    { id: 3, name: "آبرسان", isCheck: false },
    { id: 4, name: "آخر عباسی", isCheck: false },
    { id: 5, name: "آرپادرسی", isCheck: false },
    { id: 6, name: "آزادی", isCheck: false },
    { id: 7, name: "ائل گلی", isCheck: false },
    { id: 8, name: "ابوریحان", isCheck: false },
    { id: 9, name: "اتوبان کسایی", isCheck: false },
    { id: 12, name: "اشرفی لاله", isCheck: false },
    { id: 18, name: "ارتش جنوبی", isCheck: false },
    { id: 19, name: "ارتش شمالی", isCheck: false },
    { id: 21, name: "الهی پرست", isCheck: false },
    { id: 22, name: "الهیه", isCheck: false },
    { id: 23, name: "امام خمینی", isCheck: false },
    { id: 24, name: "امام رضا", isCheck: false },
    { id: 25, name: "امیرخیزی", isCheck: false },
    { id: 26, name: "اهراب", isCheck: false },
    { id: 27, name: "اول عباسی", isCheck: false },
    { id: 28, name: "ایپکچیلر", isCheck: false },
    { id: 29, name: "بارنج", isCheck: false },
    { id: 30, name: "بازار", isCheck: false },
    { id: 31, name: "باغچه بان", isCheck: false },
    { id: 32, name: "باغ شمال", isCheck: false },
    { id: 33, name: "بعثت", isCheck: false },
    { id: 34, name: "بلوار 29 بهمن", isCheck: false },
    { id: 35, name: "بلوار استاد شهریار", isCheck: false },
    { id: 36, name: "بلوار شهدا", isCheck: false },
    { id: 37, name: "بهادری", isCheck: false },
    { id: 38, name: "بهاران", isCheck: false },
    { id: 39, name: "پاستور", isCheck: false },
    { id: 40, name: "پاسداران", isCheck: false },
    { id: 41, name: "پرواز", isCheck: false },
    { id: 42, name: "پل سنگی", isCheck: false },
    { id: 43, name: "پل قاری", isCheck: false },
    { id: 44, name: "تپلی باغ", isCheck: false },
    { id: 45, name: "تربیت", isCheck: false },
    { id: 46, name: "توانیر", isCheck: false },
    { id: 47, name: "توکلی", isCheck: false },
    { id: 48, name: "جاده پالایشگاه", isCheck: false },
    { id: 49, name: "جاده تبریز تهران", isCheck: false },
    { id: 50, name: "جاده تبریز مراغه", isCheck: false },
    { id: 51, name: "جاده تبریز مرند", isCheck: false },
    { id: 52, name: "جاده تهران", isCheck: false },
    { id: 53, name: "جاده سنتو", isCheck: false },
    { id: 54, name: "جاده صنعتی", isCheck: false },
    { id: 55, name: "جاده فرودگاه", isCheck: false },
    { id: 56, name: "جاده قدیم اهر", isCheck: false },
    { id: 57, name: "جمهوری اسلامی", isCheck: false },
    { id: 58, name: "چایکنار", isCheck: false },
    { id: 59, name: "چهارراه باغشمال", isCheck: false },
    { id: 60, name: "چهارراه شریعتی", isCheck: false },
    { id: 61, name: "چهارراه عباسی", isCheck: false },
    { id: 62, name: "چهارراه لاله", isCheck: false },
    { id: 63, name: "چهارراه منصور", isCheck: false },
    { id: 64, name: "حاج جبارنائب", isCheck: false },
    { id: 65, name: "حاج هاشم", isCheck: false },
    { id: 66, name: "حافظ", isCheck: false },
    { id: 67, name: "خاقانی", isCheck: false },
    { id: 68, name: "خطیب", isCheck: false },
    { id: 69, name: "خیام", isCheck: false },
    { id: 70, name: "دادگستری", isCheck: false },
    { id: 71, name: "دارائی", isCheck: false },
    { id: 72, name: "دارائی جدید", isCheck: false },
    { id: 73, name: "داش ساختمان", isCheck: false },
    { id: 74, name: "دامپزشکی", isCheck: false },
    { id: 75, name: "ستارخان", isCheck: false },
    { id: 76, name: "سردرود", isCheck: false },
    { id: 77, name: "سعدی", isCheck: false },
    { id: 78, name: "سه راه امین", isCheck: false },
    { id: 79, name: "سه راه طالقانی", isCheck: false },
    { id: 80, name: "سه راه مارالان", isCheck: false },
    { id: 81, name: "سه راه محققی", isCheck: false },
    { id: 82, name: "سه راه اهر", isCheck: false },
    { id: 83, name: "سهند", isCheck: false },
    { id: 84, name: "شریعتی جنوبی", isCheck: false },
    { id: 85, name: "شریعتی شمالی", isCheck: false },
    { id: 86, name: "ششگلان", isCheck: false },
    { id: 87, name: "شکرچیلر", isCheck: false },
    { id: 88, name: "شمس تبریزی", isCheck: false },
    { id: 89, name: "شنب غازان", isCheck: false },
    { id: 90, name: "شهرک آزمایش", isCheck: false },
    { id: 91, name: "شهرک استانداری", isCheck: false },
    { id: 92, name: "شهرک اندیشه", isCheck: false },
    { id: 93, name: "شهرک باغمیشه", isCheck: false },
    { id: 94, name: "شهرک صنعتی مایان", isCheck: false },
    { id: 95, name: "شهرک فرهنگیان", isCheck: false },
    { id: 96, name: "شهرک نصر3", isCheck: false },
    { id: 97, name: "شهید باکری", isCheck: false },
    { id: 98, name: "شهید بهشتی", isCheck: false },
    { id: 99, name: "شهید جدیری", isCheck: false },
    { id: 100, name: "طالقانی", isCheck: false },
    { id: 101, name: "عارف", isCheck: false },
    { id: 102, name: "عباسی", isCheck: false },
    { id: 103, name: "فردوس", isCheck: false },
    { id: 104, name: "فردوسی", isCheck: false },
    { id: 105, name: "فرشته جنوبی", isCheck: false },
    { id: 106, name: "فرشته شمالی", isCheck: false },
    { id: 107, name: "قطران", isCheck: false },
    { id: 108, name: "کلانترکوچه", isCheck: false },
    { id: 109, name: "کوچه حسن", isCheck: false },
    { id: 110, name: "کوی فیروز", isCheck: false },
    { id: 111, name: "کوی لاله", isCheck: false },
    { id: 112, name: "گازران", isCheck: false },
    { id: 113, name: "گلشن", isCheck: false },
    { id: 114, name: "گلشهر", isCheck: false },
    { id: 115, name: "گلکار", isCheck: false },
    { id: 116, name: "گلگشت", isCheck: false },
    { id: 117, name: "لاله", isCheck: false },
    { id: 118, name: "لاله زار", isCheck: false },
    { id: 119, name: "مارالان", isCheck: false },
    { id: 120, name: "مایان", isCheck: false },
    { id: 121, name: "مسجدکبود", isCheck: false },
    { id: 122, name: "مقصودیه", isCheck: false },
    { id: 123, name: "ملل متحد", isCheck: false },
    { id: 124, name: "منصور", isCheck: false },
    { id: 125, name: "منظریه", isCheck: false },
    { id: 126, name: "میدان آذربایجان", isCheck: false },
    { id: 127, name: "میدان رسالت", isCheck: false },
    { id: 128, name: "میدان شهدا", isCheck: false },
    { id: 129, name: "میدان قطب", isCheck: false },
    { id: 130, name: "میدان نماز", isCheck: false },
    { id: 131, name: "میرداماد", isCheck: false },
    { id: 132, name: "نصف راه", isCheck: false },
    { id: 133, name: "نگین پارک", isCheck: false },
    { id: 134, name: "هفت تیر", isCheck: false },
    { id: 135, name: "وادی رحمت", isCheck: false },
    { id: 136, name: "ولی امر", isCheck: false },
    { id: 137, name: "ولیعصر جنوبی", isCheck: false },
    { id: 138, name: "ولیعصر شمالی", isCheck: false },
    { id: 139, name: "ویلاشهر", isCheck: false },
    { id: 140, name: "یاغچیان", isCheck: false },
    { id: 141, name: "زعفرانیه", isCheck: false },
    { id: 142, name: "فلکه دانشگاه", isCheck: false },
    { id: 143, name: "رشدیه", isCheck: false },
    { id: 144, name: "خاوران", isCheck: false },
    { id: 145, name: "مرزداران", isCheck: false },
    { id: 146, name: "سپهر صادرات", isCheck: false },
    { id: 147, name: "باسمنج", isCheck: false },
    { id: 148, name: "رجایی شهر", isCheck: false },
    { id: 149, name: "گلباد", isCheck: false },
    { id: 150, name: "میدان ساعت", isCheck: false },
]

export default place